// core/data/creators-hub.ts — Typed seed for the Creators' Hub page.
//
// Faithful port of legacy src/scripts/data/creators-hub.js.
// `collaborations` and `invites` are mutable (interest toggle / accept-decline).
// Authors reference existing user records for consistent avatars/handles.

import type { HubDiscussion, HubCollaboration, HubInvite, HubEvent } from '@/core/models/creators-hub';

export const seedDiscussions: HubDiscussion[] = [
  {
    id: 'd-1', name: 'Jordan Lee', handle: '@jlee', av: 'av-4', time: '2h',
    topic: 'Open Source',
    body: "What's your sustainable funding model for OSS? Sharing what's actually worked for me this year.",
    replies: 14, cheers: 32,
  },
  {
    id: 'd-2', name: 'Sara Kim', handle: '@sarak', av: 'av-5', time: '5h',
    topic: 'Design',
    body: 'Hot take: most creator tools optimize for output, not craft. Convince me otherwise.',
    replies: 9, cheers: 21,
  },
  {
    id: 'd-3', name: 'Maya Patel', handle: '@mayap', av: 'av-2', time: '8h',
    topic: 'Security',
    body: 'PSA for creators: rotate your API keys before you ship that shiny new automation.',
    replies: 6, cheers: 18,
  },
  {
    id: 'd-4', name: 'FreedomSeeker', handle: '@FreedomSeeker', av: 'av-1', time: '1d',
    topic: 'Free Press',
    body: 'How are independent creators handling source protection? Trading notes. Reply in.',
    replies: 11, cheers: 27,
  },
];

export const seedCollaborations: HubCollaboration[] = [
  {
    id: 'cl-1', name: 'Jordan Lee', handle: '@jlee', av: 'av-4',
    title: 'Co-maintainer for a CLI toolkit',
    need: 'Looking for a Rust-comfortable creator to co-maintain and split releases.',
    tags: ['#OpenSource', '#Rust'], interested: 7, youInterested: false,
  },
  {
    id: 'cl-2', name: 'Sara Kim', handle: '@sarak', av: 'av-5',
    title: 'Designer + writer for a quarterly zine',
    need: 'Need a writer to pair with on a design zine: words meet pixels.',
    tags: ['#Design', '#Writing'], interested: 4, youInterested: false,
  },
  {
    id: 'cl-3', name: 'Maya Patel', handle: '@mayap', av: 'av-2',
    title: 'Co-author a monthly appsec column',
    need: 'Seeking a creator to co-write a plain-language security column for builders.',
    tags: ['#Security', '#Writing'], interested: 5, youInterested: false,
  },
];

export const seedInvites: HubInvite[] = [
  {
    id: 'iv-1', name: 'FreedomSeeker', handle: '@FreedomSeeker', av: 'av-1', kind: 'collab',
    text: 'Invited you to collaborate on a free-press explainer series.',
  },
  {
    id: 'iv-2', name: 'OpenMind', handle: '@OpenMindX', av: 'av-3', kind: 'event',
    text: "Invited you to the 'Good-Faith Debate' creator AMA.",
  },
  {
    id: 'iv-3', name: 'LibertyMind', handle: '@LibertyMind', av: 'av-2', kind: 'collab',
    text: 'Invited you to co-host a philosophy livestream.',
  },
];

export const seedEvents: HubEvent[] = [
  { id: 'ev-1', title: 'Creator AMA: Funding Your Work', date: 'Jun 2',  blurb: 'A live Q&A on sustainable creator income.' },
  { id: 'ev-2', title: 'Design Systems Jam',             date: 'Jun 9',  blurb: 'Hands-on session for product-minded creators.' },
  { id: 'ev-3', title: 'Security for Creators',          date: 'Jun 16', blurb: 'Protect your accounts, keys, and audience.' },
];

export const seedFeaturedCreatorHandles: string[] = ['@mayap', '@jlee', '@sarak'];
